module.exports = __webpack_public_path__ + "img/health_1.d14ec8e9.png";